import { AfterViewInit, Component, Input, OnDestroy } from '@angular/core';

import { BaseUI } from '../../base.ui';
import { ClientRelation, ClientType } from '../../../../core';
import { FullClient } from '../../../domain/data';
import { ParentEvents } from '../../../utils/parent-events.service';

@Component({
    selector: 'thr-full-data-pupils-table',
    templateUrl: './full-data-pupils-table.component.html',
    styleUrls: ['./full-data-pupils-table.component.scss'],
})
export class FullDataPupilsTableComponent extends BaseUI implements AfterViewInit, OnDestroy {
    public ClientRelation: typeof ClientRelation = ClientRelation;
    public ClientType: typeof ClientType = ClientType;

    @Input()
    pupils: FullClient[] = [];

    constructor(parentEvents: ParentEvents) {
        super(parentEvents);
    }
}
